// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3h2_v){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_snjks .dualColumn_1NGwl{display:flex;align-content:space-between}.nsAddressForm_snjks .dualColumn_1NGwl .firstCol_14Lkk{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3h2_v",
	"nsAddressForm": "nsAddressForm_snjks",
	"dualColumn": "dualColumn_1NGwl",
	"firstCol": "firstCol_14Lkk"
};
module.exports = exports;
